<template>
  <div class="main_center">
    <div class="content">
        <div class="search-content">
            <div class="mainBtn">
                <el-button @click="routerAdd" size="small"
                           type="primary"
                           v-if="hasBtnPermission('btn_jz_pm_dgwitness_guard_config_add')">新增</el-button>
                <el-button @click="deleteSelectItem()"
                           size="small"
                           v-if="hasBtnPermission('btn_jz_pm_dgwitness_guard_config_delete')">删除
                </el-button>
            </div>
            <div class="searchBtn">
                <span class="label-form">关键字搜索：</span>
                <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入内容搜索" style="width: 200px" v-model="form.search"></el-input>
                <span class="label-form">发布状态：</span>
                <el-select @change="searchBtn" clearable style="width:150px;display: inline-block" v-model="form.pubFlag" value-key="value">
                    <el-option label="已发布" value="1"></el-option>
                    <el-option label="未发布" value="0"></el-option>
                </el-select>
                <el-button @click="searchBtn" size="small" style="margin-left: 12px" type="primary">搜索</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button @click="refresh" icon="el-icon-refresh" type="text"></el-button>
            </div>
        </div>
      <el-table :data="tableData"
                ref="multipleTable"
                class="table-content"
                :header-cell-style="this.$globalGrayTableHeaderStyle"
                v-loading="dataListLoading"
                :height="tableMaxHeight"
                stripe border
                @selection-change="handleSelectionChange">
                <el-table-column fixed type="selection" v-if="hasBtnPermission('btn_jz_pm_dgwitness_guard_config_delete')" align="center"
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column fixed label="序号" type="index" :index="indexMethod" width="50" align="center"
                         :show-overflow-tooltip='true'></el-table-column>
        
        <el-table-column fixed="right" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" title="查看"
                       v-if="hasBtnPermission('btn_jz_pm_dgwitness_guard_config_view')"
                       @click="router(scope.row)">查看</el-button>
            <el-button type="text" title="删除"
                       v-if="hasBtnPermission('btn_jz_pm_dgwitness_guard_config_delete')"
                       @click="deleteById(scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="名称" prop='name' header-align="center" align="left" min-width='100'
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="流id" prop='streamId' header-align="center" align="center" min-width='100'
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="流媒体地址" prop='streamUrl' header-align="center" align="center" min-width='100'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="门禁位置" prop='locationName' header-align="center" align="left" min-width='100'
                         :show-overflow-tooltip='true'>
        </el-table-column>
          <el-table-column label="所属交易中心" prop='tradeOrgName' header-align="center" align="left" min-width='100'
                           :show-overflow-tooltip='true'>
          </el-table-column>
        <el-table-column label="发布标记" prop='pubFlag' header-align="center" align="center" width="150"
                         :show-overflow-tooltip='true'>
          <template slot-scope="scope" >
            <el-tag   size="small" :hit="false" effect="plain"  > {{scope.row.pubFlag==0?"未发布":"已发布"}}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background
                     layout="total, sizes, prev, pager, next"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="pageSize"
                     :total="total"
                     :current-page="pageIndex"
                     @size-change="sizeChangeHandle"
                     @current-change="currentChangeHandle"></el-pagination>
    </div>
  </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
  data() {
    return {
      tableMaxHeight: document.documentElement.clientHeight - 227,
        dataListLoading: false,
      form: {
        search:'' ,//搜索框的值
        pubFlag:'',
      },
      moreSearchItem: false,
      checkList1: '',
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数
      tableData: [],
      multipleSelection: [],
      user: '', //角色类型
      formData: {}
    }
  },
  computed: {
    ...mapState({
      stateData: state => state.user
    }),
  },
  filters: {
    ellipsis(text, num) {
      if (text.length > num) {
        return text.substring(0, num) + '...';
      } else {
        return text;
      }
    },
  },
  activated() {
    //this.user = this.stateData.pageRoleIds //角色类型
    // this.refresh();
    this.getDataList()
  },
  mounted() {
    const that = this;
    let resizeTag = true
    window.onresize = () => {
      if (resizeTag) { //防抖动
        that.ifmove();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
    that.ifmove();
  },
  methods: {
    ifmove() {
        // let hasBtnPermisson = this.hasBtnPermission('btn_jz_pm_dgwitness_guard_config_delete') || this.hasBtnPermission('btn_jz_pm_dgwitness_guard_config_add');
      let tableMaxHeight = document.documentElement.clientHeight - 227;
      this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
        this.$nextTick(() => {
            this.tableMaxHeight = tableMaxHeight
        })
      //this.getDataList()
    },



    getDataList() { // 获取列表数据
        this.dataListLoading=true;
      this.$httpReq.post('/sysGuardConfig/list', {
        'page': this.pageIndex,
        'rows': this.pageSize,
        'searchKey': this.form.search,
        'filter': this.form
      }).then(res => {
        this.tableData = res.data.rows;
        this.total = res.data.total;
        this.$refs.multipleTable.doLayout();
          this.dataListLoading=false;
      })
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    searchBtn() { //搜索按钮
      this.pageIndex = 1;
      this.pageSize = 10;
      this.getDataList()
    },
    refresh() {//刷新按钮
        this.pageIndex = 1;
      this.form.search = "";
      this.form.pubFlag = "";
      this.getDataList()

    },

    routerAdd(){ //新增
      window.sessionStorage.setItem("addUpdateIndex",2);

      window.sessionStorage.setItem("id", '');

      this.$router.push({
        name:'guard_config_detail'
      })

    },

    router(item){ // 跳转详情
      var id = item.id;
      window.sessionStorage.setItem("id", id);
      window.sessionStorage.setItem("addUpdateIndex",1)

      this.$router.push({
        name:'guard_config_view'
      })

    },



    deleteById(item) {
      this.$confirm(`确定要删除该数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      this.$httpReq.post('/sysGuardConfig/delete', {
        id: item.id
      }).then(res => {
        if (res.data.code == '1') {
          this.$message({
            type: 'success',
            message: res.data.msg
          })
          this.getDataList();
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      })
      })
    },
    deleteSelectItem() {
      let ids = new Array();
      this.multipleSelection.forEach(key => {
        ids.push(key.id)
      })

      if (ids != "" || ids.length > 0) {
        this.$httpReq.post('/sysGuardConfig/delete', {
          idList: ids
        }).then(res => {
          if (res.data.code == '1') {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.getDataList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      } else {
        this.$message({
          type: 'error',
          message: "未选择删除项。"
        })
      }

    },

    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1
      this.getDataList()
    },

    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },



  }


}
</script>

<style lang="scss">
.main_center {
  .top {
    .input_title {
      display: flex;
    }

    .el-form-item {
      margin-bottom: 0;
    }
  }
}

.margin-hide {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>